module.exports = __webpack_public_path__ + "img/logo.becd07b4.svg";